export default __webpack_public_path__ + "static/media/avatar13-mujer.77abc940.png";